function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.array.slice.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 *  Cart Drawer
 *    Provides scripts for the cart drawer.
 *
 *  Version:
 *    1.0.0 - 2020/03/16
 */

import { handlize } from '@process-creative/slate-theme-tools';
import * as ResponsiveSizes from './../../settings/Responsive';
import { register, ShopifySection } from './../ShopifySection';
import { CartQuantitySelector } from './../../objects/quantity/CartQuantitySelector';
import Cookies from 'js-cookie';
import { getCurrentCart, removeFromCart, ON_CART_FINISHED, ON_CART_PENDING, printMoney, formatMoney } from '@process-creative/slate-theme-tools';
import { current } from 'lity';

//Selectors
export var CONTAINER_SELECTOR = '[data-cart-drawer]';
export var CART_DRAWER_TOGGLE = '[data-cart-drawer-toggle]';
export var CART_DRAWER_ITEM_COUNT = '[data-cart-drawer-item-count]';
export var CART_DRAWER_PRODUCTS = '[data-cart-drawer-products]';
export var CART_PRODUCT_REMOVE = '[data-cart-remove]';
export var CART_UPSELL_CONTAINER = '[data-cart-upsell]';
export var CART_UPSELL_CLOSE = '[data-cart-upsell-close]';
export var CART_UPSELL_ADD = '[data-cart-upsell-add-btn]';
export var CART_DRAWER_SUBTOTAL = '[data-cart-drawer-subtotal]';
export var ALTERNATE_PAYMENT_PRICE = '[data-alternate-money-price]';
export var TREE_COUNT = '[data-cart-drawer-tree-count]';
export var PROMO_TIER_MESSAGE = '[data-cart-tiers-tier]';
export var PROMO_TIER_REMAINING = '[data-cart-tiers-tier-remaining]';
export var PROMO_TIER_PROGRESS = '[data-cart-tiers-tier-progress]';
export var CART_ITEM_COLLECTIONS = '[data-cart-product-collections]';
export var CART_DRAWER_CHECKOUT = '[data-cart-drawer-checkout]';

//Attrs
export var CART_PRODUCT_SELECTOR = 'data-cart-product';
export var TREE_COUNT_VALUE = 'data-cart-drawer-tree-value';
export var PROMO_TIER_MIN = 'data-cart-tiers-tier-min';
export var PROMO_TIER_MAX = 'data-cart-tiers-tier-max';
export var PROMO_TIER_CURRENCY = 'data-cart-tiers-tier-currency';
export var CART_UPSELL_COLLECTION = 'data-cart-drawer-upsell-collection';
var ATTR_TREE_COUNT_NFT = 'data-cart-drawer-nft-tree-value';

//Classes
export var CLASS_CART_DRAWER_OPEN = 'is-cart-open';
export var CLASS_HAS_ITEMS = 'has-items';
export var CLASS_HIDDEN = 'is-hidden';
export var CLASS_VISIBLE = 'is-visible';
export var CLASS_ACTIVE = 'is-active';
export var CLASS_SUCCESS = 'is-tier-success';
export var UPSELL_COOKIE = '_hide-upsell';
export var CartDrawer = /*#__PURE__*/function (_ShopifySection) {
  _inherits(CartDrawer, _ShopifySection);
  var _super = _createSuper(CartDrawer);
  function CartDrawer(container) {
    var _this;
    _classCallCheck(this, CartDrawer);
    _this = _super.call(this, container);
    _this.qtySelectors = [];
    _this.body = $('body');
    _this.drawerTargets = [_this.body, _this.container];
    _this.itemsCount = container.find(CART_DRAWER_ITEM_COUNT);
    _this.cartDrawerProducts = container.find(CART_DRAWER_PRODUCTS);
    _this.cartUpsell = container.find(CART_UPSELL_CONTAINER);
    _this.upsellCollection = container.attr(CART_UPSELL_COLLECTION);
    _this.subtotal = container.find(CART_DRAWER_SUBTOTAL);
    _this.alternatePayment = container.find(ALTERNATE_PAYMENT_PRICE);
    _this.treeValue = container.attr(TREE_COUNT_VALUE);
    _this.treeValueNft = container.attr(ATTR_TREE_COUNT_NFT);
    _this.treeCount = container.find(TREE_COUNT);
    _this.cartPromoMessage = container.find(PROMO_TIER_MESSAGE);
    _this.checkout = container.find(CART_DRAWER_CHECKOUT);
    _this.setupQuantitySelectors();
    _this.checkUpsellProduct();

    //Events
    var cartButtons = document.querySelectorAll(CART_DRAWER_TOGGLE);
    cartButtons.forEach(function (cartButton) {
      cartButton.addEventListener('click', _this.onCartToggle.bind(_assertThisInitialized(_this)));
    });
    $(document).on(ON_CART_FINISHED, function () {
      return _this.fetchCartContents();
    });
    container.on('click', CART_UPSELL_CLOSE, function (e) {
      return _this.onUpsellClose(e);
    });
    container.on('click', CART_PRODUCT_REMOVE, function (e) {
      return _this.removeItem(e);
    });
    _this.checkout.click(function (e) {
      e.preventDefault();
      window.dataLayer = window.dataLayer || [];
      var currentCart = getCurrentCart();
      var savedGoogleAnalyticsData = JSON.parse(sessionStorage.getItem('ga_items') || '[]');
      var checkoutItems = currentCart.items.map(function (item) {
        var productExists = savedGoogleAnalyticsData.find(function (saved_item) {
          return saved_item.item_id == item.product_id;
        }) || {};
        return _objectSpread({
          item_name: item.product_title,
          item_id: item.product_id,
          price: (item.price / 100).toFixed(2),
          currency: Shopify.currency.active,
          item_brand: 'Urth',
          item_category: item.product_type,
          item_variant: item.variant_title,
          quantity: item.quantity
        }, productExists);
      });
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: Shopify.currency.active,
          value: (currentCart.total_price / 100).toFixed(2),
          items: checkoutItems
        }
      });
      window.location.href = '/checkout';
    });
    return _this;
  }
  _createClass(CartDrawer, [{
    key: "checkUpsellProduct",
    value: function checkUpsellProduct() {
      //Update status of the upsell product, hide if there's one from this collection in the cart
      var collectionEl = this.container.find(CART_ITEM_COLLECTIONS);
      var colData = JSON.parse(collectionEl.html());
      if (colData.indexOf(this.upsellCollection) != -1 || Cookies.get(UPSELL_COOKIE)) {
        this.cartUpsell.addClass(CLASS_HIDDEN);
      } else {
        this.cartUpsell.removeClass(CLASS_HIDDEN);
      }
    }
  }, {
    key: "fetchCartContents",
    value: function () {
      var _fetchCartContents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var cartContent, cart, subtotal, alternatePayment, count, cartCurrency;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //Fetch the AJAX view for the cart
              cartContent = '';
              _context.prev = 1;
              _context.next = 4;
              return new Promise(function (resolve, reject) {
                $.ajax({
                  url: '/cart',
                  data: {
                    view: 'ajax'
                  },
                  success: function success(d) {
                    return resolve(d);
                  },
                  error: function error(jqXHR, status, _error) {
                    return reject(_error);
                  }
                });
              });
            case 4:
              cartContent = _context.sent;
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              //Error when fetching cart body
              console.error(_context.t0);
            case 10:
              if (!(!cartContent || !cartContent.length)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return");
            case 12:
              //Update HTML of our cart products
              this.cartDrawerProducts.html(cartContent);

              //Get the current cart object...
              cart = getCurrentCart();
              subtotal = cart.items_subtotal_price;
              alternatePayment = subtotal / 4; //Re-attach Quantity Selectors with their logic.
              this.setupQuantitySelectors();

              //Update the subtotal
              this.subtotal.attr('data-money', subtotal);
              this.subtotal.html(printMoney(subtotal, 'money_with_currency_format').replace('.00', ''));
              count = cart.item_count;
              cartCurrency = window.Currency.currency; //Update content based on cart items
              if (!(count == 0)) {
                _context.next = 25;
                break;
              }
              this.itemsCount.html('');
              this.container.removeClass(CLASS_HAS_ITEMS);
              // this.cartPromoMessage.removeClass(CLASS_VISIBLE);
              return _context.abrupt("return");
            case 25:
              this.container.addClass(CLASS_HAS_ITEMS);
              this.itemsCount.html("(".concat(count, ")"));
              this.alternatePayment.html(printMoney(alternatePayment, 'money_with_currency_format').replace('.00', ''));
              this.updateTreeCounter(cart);
              this.checkUpsellProduct();

              //Update our promo messaging
              this.cartPromoMessage.each(function (i, e) {
                var message = $(e);
                var rElement = message.find(PROMO_TIER_REMAINING);
                var pElement = message.find(PROMO_TIER_PROGRESS);
                var min = message.attr(PROMO_TIER_MIN) || 0;
                var max = message.attr(PROMO_TIER_MAX) || 0;
                var remaining = max - subtotal;
                var supportedCurrencies = message.attr(PROMO_TIER_CURRENCY);

                //Update remaining value
                if (rElement.length) {
                  rElement.attr('data-money', remaining);
                  rElement.html(printMoney(remaining, 'money_with_currency_format').replace('.00', ''));
                  var percent = subtotal / max * 100;
                  pElement.css('width', "".concat(percent, "%"));
                }

                //Hide or show
                if (supportedCurrencies.indexOf(cartCurrency) === -1) {
                  message.removeClass(CLASS_ACTIVE);
                  message.removeClass(CLASS_SUCCESS);
                } else if (subtotal > min && subtotal < max) {
                  message.addClass(CLASS_ACTIVE);
                  message.removeClass(CLASS_SUCCESS);
                } else if (subtotal > max) {
                  message.addClass(CLASS_SUCCESS);
                  message.removeClass(CLASS_ACTIVE);
                } else {
                  message.removeClass(CLASS_ACTIVE);
                  message.removeClass(CLASS_SUCCESS);
                }
              });

              //Finally, show the cart if it wasn't already visible.
              if (!this.container.hasClass(CLASS_CART_DRAWER_OPEN)) this.open();
            case 32:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 7]]);
      }));
      function fetchCartContents() {
        return _fetchCartContents.apply(this, arguments);
      }
      return fetchCartContents;
    }()
  }, {
    key: "onCartToggle",
    value: function onCartToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.container.hasClass(CLASS_CART_DRAWER_OPEN)) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: "onUpsellClose",
    value: function onUpsellClose(e) {
      e.preventDefault();
      e.stopPropagation();
      this.cartUpsell.addClass(CLASS_HIDDEN);
      Cookies.set(UPSELL_COOKIE, 'true');
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;
      //Set the height of the screen to prevent background scrolling
      var width = $(window).width();
      var vpH = $(window).innerHeight();
      setTimeout(function () {
        _this2.body.css('height', "".concat(vpH.toString(), "px"));
      }, 500);
      this.drawerTargets.forEach(function (e) {
        return $(e).addClass(CLASS_CART_DRAWER_OPEN);
      });
      if (width > ResponsiveSizes.small - 1) return;
    }
  }, {
    key: "close",
    value: function close() {
      this.drawerTargets.forEach(function (e) {
        return $(e).removeClass(CLASS_CART_DRAWER_OPEN);
      });
      this.body.css('height', '');
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(e.currentTarget);
      var product = self.closest("[".concat(CART_PRODUCT_SELECTOR, "]"));
      var index = product.attr('data-index');

      // Storing the current state of cart before items are removed
      var _getCurrentCart = getCurrentCart(),
        cartItems = _getCurrentCart.items;
      //Now remove Item
      try {
        removeFromCart(index);
        var savedGoogleAnalyticsData = JSON.parse(sessionStorage.getItem('ga_items') || '[]');

        // Getting the line item from the cart based on the index attribute 
        var itemData = cartItems[index - 1];
        var productExists = savedGoogleAnalyticsData.find(function (saved_item) {
          return saved_item.item_id == itemData.product_id;
        }) || {};
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'remove_from_cart',
          ecommerce: {
            currency: Shopify.currency.active,
            value: (itemData.price / 100).toFixed(2),
            items: [_objectSpread({
              item_name: itemData.product_title,
              item_id: itemData.product_id,
              price: (itemData.price / 100).toFixed(2),
              currency: Shopify.currency.active,
              item_brand: 'Urth',
              item_category: itemData.product_type,
              item_variant: itemData.variant_title,
              quantity: itemData.quantity
            }, productExists)]
          }
        });
        dataLayer.push({
          ecommerce: null
        });
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "setupQuantitySelectors",
    value: function setupQuantitySelectors() {
      var _this3 = this;
      //Destroy
      this.qtySelectors.forEach(function (e) {
        return e.destroy();
      });

      //Now recreate
      this.qtySelectors = [];
      $("[".concat(CART_PRODUCT_SELECTOR, "]")).each(function (e, i) {
        var self = $(i);
        var index = self.attr('data-index');
        _this3.qtySelectors.push(new CartQuantitySelector(index, self));
      });
    }
  }, {
    key: "updateTreeCounter",
    value: function updateTreeCounter(cart) {
      var _this4 = this;
      var count = cart.items.reduce(function (x, item) {
        var type = item.product_type ? handlize(item.product_type) : '';
        if (type === 'gicl-e-print' || type.includes('art-frame')) {
          return x;
        } else if (type === 'nft-art') {
          return x + _this4.treeValueNft * item.quantity;
        } else {
          return x + _this4.treeValue * item.quantity;
        }
      }, 0);
      this.treeCount.html(count);
    }
  }]);
  return CartDrawer;
}(ShopifySection);
register(CONTAINER_SELECTOR, CartDrawer);